import formReducer from './reducers/formSlice.js'

const store = {
  form: formReducer,
}

export default store;